import React, { useRef, useEffect, useState } from "react";
import * as facemesh from "@tensorflow-models/face-landmarks-detection";
import Webcam from "react-webcam";
import { drawMesh } from "./Utilities";
import * as tf from "@tensorflow/tfjs";
import { BrowserView, MobileView } from "react-device-detect";

function FaceLandmark() {
  const webcamRef = useRef(null);
  const canvasRef = useRef(null);
  const [isFlipped, setIsFlipped] = useState(true);

  const [isLoading, setIsLoading] = useState(false);
  const [predicting, setPredicting] = useState(false);
  const [captureIntervalId, setCaptureIntervalId] = useState(null);

  const holdingArraySize = 7;
  const maxValue = 2;
  const blinkThreshold = 8; // Adjust this threshold as needed

  const [leftEyeBlinkArray, setLeftEyeBlinkArray] = useState(
    Array(holdingArraySize).fill(0)
  );

  const [rightEyeBlinkArray, setRightEyeBlinkArray] = useState(
    Array(holdingArraySize).fill(0)
  );

  const [leftEyeBlinkCounter, setLeftEyeBlinkCounter] = useState(0);
  const [rightEyeBlinkCounter, setRightEyeBlinkCounter] = useState(0);

  const videoClassName = isFlipped ? "flipped-video" : "";

  const toggleFlip = () => {
    setIsFlipped((prev) => !prev);
  };

  const pushToLeftArray = (array, value, maxSize) => {
    setLeftEyeBlinkArray((arr) => {
      // console.log(
      //   "LEFT=>ARRAY",
      //   arr,
      //   value,
      //   arr.some((val) => val <= blinkThreshold)
      // );
      if (Array.isArray(arr) && arr.length >= maxSize) {
        arr.shift(); // Remove the oldest element if the array is at max size
      }
      if (
        value > blinkThreshold ||
        //  && !arr.some((val) => val === value)
        (value <= blinkThreshold &&
          arr.filter((val) => val <= blinkThreshold).length <= 1)
      ) {
        return [...arr, value];
      } else {
        return arr;
      }
    });
  };

  const pushToRightArray = (array, value, maxSize) => {
    setRightEyeBlinkArray((arr) => {
      // console.log(
      //   "RIGHT=> ARRAY",
      //   arr,
      //   value,
      //   arr.some((val) => val <= blinkThreshold)
      // );
      if (Array.isArray(arr) && arr.length >= maxSize) {
        arr.shift(); // Remove the oldest element if the array is at max size
      }
      if (
        value > blinkThreshold ||
        //  && !arr.some((val) => val === value)
        (value <= blinkThreshold &&
          arr.filter((val) => val <= blinkThreshold).length <= 1)
      ) {
        return [...arr, value];
      } else {
        return arr;
      }
    });
  };

  const runFacemesh = async () => {
    setIsLoading(true);
    setPredicting(true);
    const net = await facemesh.load(
      facemesh.SupportedPackages.mediapipeFacemesh,
      {
        maxFaces: 1
      }
    );
    const intervalId = setInterval(() => {
      detect(net);
      // call detect faces every 100 milliseconds or 10 times every second
    }, 100);
    setCaptureIntervalId(intervalId);
  };

  const stopFacemesh = () => {
    setRightEyeBlinkCounter(0);
    setLeftEyeBlinkCounter(0);
    setIsLoading(false);
    if (captureIntervalId) {
      clearInterval(captureIntervalId);
      setCaptureIntervalId(null);
    }
  };

  const capture = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    console.log(imageSrc);
    console.log('test');
    const message = imageSrc;
    window.parent.postMessage(message, "*");
    return imageSrc
  }


  const detect = async (net) => {
    if (
      typeof webcamRef.current !== "undefined" &&
      webcamRef.current !== null &&
      webcamRef.current.video.readyState === 4
    ) 
    {
      const video = webcamRef.current.video;
      const videoWidth = webcamRef.current.video.videoWidth;
      const videoHeight = webcamRef.current.video.videoHeight;

      webcamRef.current.video.width = videoWidth;
      webcamRef.current.video.height = videoHeight;

      canvasRef.current.width = videoWidth;
      canvasRef.current.height = videoHeight;

      const face = await net.estimateFaces({ input: video });
      if (face.length > 0) {
        face.forEach((prediction) => {
          const rightEyeUpper0 = prediction.annotations.rightEyeUpper0;
          const rightEyeLower0 = prediction.annotations.rightEyeLower0;
          const leftEyeUpper0 = prediction.annotations.leftEyeUpper0;
          const leftEyeLower0 = prediction.annotations.leftEyeLower0;

          const rightEyeCenterPointDistance = Math.abs(
            rightEyeUpper0[3][1] - rightEyeLower0[4][1]
          ).toFixed();

          const leftEyeCenterPointDistance = Math.abs(
            leftEyeUpper0[3][1] - leftEyeLower0[4][1]
          ).toFixed();

          pushToRightArray(
            rightEyeBlinkArray,
            rightEyeCenterPointDistance,
            holdingArraySize
          );

          pushToLeftArray(
            leftEyeBlinkArray,
            leftEyeCenterPointDistance,
            holdingArraySize
          );
        });
      }

      setPredicting(false);

      const ctx = canvasRef.current.getContext("2d");
      requestAnimationFrame(() => {
        drawMesh(face, ctx);
      });

    }
  };

  useEffect(() => {
    if (rightEyeBlinkCounter >= maxValue && leftEyeBlinkCounter>=maxValue){
      //capture base64 data after 2 sec
      setTimeout(() => {
        capture();
      }, 800);
      //Stop prog 
      stopFacemesh();
      //Set loading param true and start program
      // setIsLoading(true);
      // runFacemesh();
    }
  }, [leftEyeBlinkCounter], [rightEyeBlinkCounter]);

  useEffect(() => {
    if (isLoading) {
      runFacemesh();
    }
  }, [isLoading]);

  //ini untuk triger dari php
  useEffect(() => {
    window.addEventListener("message", function (event) {
      console.log("Message received from the parent: " + event.data); // Message received from child
      const Triger = event.data;
      if(Triger=="MULAI"){
        setIsLoading(true);
      }
      if(Triger=="STOP"){
        stopFacemesh();
      }
    });
  })

  useEffect(() => {
    if (Array.isArray(leftEyeBlinkArray)) {
      if (leftEyeBlinkArray.every((val) => val > 0)) {
        if (leftEyeBlinkArray.some((val) => val <= blinkThreshold)) {
          setLeftEyeBlinkArray(() => Array(holdingArraySize).fill(0));
          setLeftEyeBlinkCounter((prev) => prev + 1);
        }
      }
    }
  }, [leftEyeBlinkArray]);

  useEffect(() => {
    if (Array.isArray(rightEyeBlinkArray)) {
      if (rightEyeBlinkArray.every((val) => val > 0)) {
        if (rightEyeBlinkArray.some((val) => val <= blinkThreshold)) {
          setRightEyeBlinkArray(() => Array(holdingArraySize).fill(0));
          setRightEyeBlinkCounter((prev) => prev + 1);
        }
      }
    }
  }, [rightEyeBlinkArray]);

  return (
    <div className="App" 
      style={{ 
        height: "120vh", 
        width: "100%",
        backgroundColor : !predicting && isLoading ? "green" : "red",
    }} >
      {/* {!isLoading && (
        <>
          <button onClick={() => setIsLoading(true)} style={{ float: "center" }}><b>Mulai Verifikasi</b></button> <nbsp/>
        </>
        )}
      {!predicting && isLoading && (
          <>
            <button onClick={stopFacemesh} style={{ float: "center" }}><b>Berhenti</b></button> <nbsp/>
          </>
      )} */}
      {/* <button onClick={toggleFlip}>
        <b>{isFlipped ? "Unflip" : "Flip"} Video</b>
      </button> */}
      <br/>
      {/* <span>{predicting ? "Loading Model " : ""}</span> */}
      <span style={{color: "#ffffff"}}>{predicting ? "Harap Tunggu Hingga Bingkai Indikator berwana Hijau" : ""}</span>
      <span style={{color: "#ffffff"}}>{!predicting && isLoading ? "Silahkan Kedipkan Mata Anda" : ""}</span>
      <br/>
      <span></span>
      {/* {!predicting && isLoading && (
        <>
          <span
            style={{
              // color: leftEyeBlinkCounter >= maxValue ? "green" : "black",
              color: "#ffffff",
              fontWeight: leftEyeBlinkCounter >= maxValue ? "bold" : ""
            }}
          >
            {" "}
            left eye = {leftEyeBlinkCounter}{" "}
          </span>
          <span
            style={{
              // color: rightEyeBlinkCounter >= maxValue ? "green" : "black",
              color: "#ffffff",
              fontWeight: rightEyeBlinkCounter >= maxValue ? "bold" : ""
            }}
          >
            {" "}
            right eye = {rightEyeBlinkCounter}{" "}
          </span>
        </>
      )} */}
      {/* <button onClick={toggleFlip} style={{ float: "right" }}>
        {isFlipped ? "Unflip" : "Flip"} Video
      </button> */}
      <BrowserView>
        <header className="App-header" style={{ width: "100%"}}>
          <Webcam
              mirrored={isFlipped}
              ref={webcamRef}
              style={{
                position: "absolute",
                marginLeft: "auto",
                marginRight: "auto",
                left: 0,
                right: 0,
                textAlign: "center",
                zIndex: 9,
                width: "90%",
                height: "90%"
              }}
            />

            <canvas
              ref={canvasRef}
              style={{
                transform: isFlipped ? "scaleX(-1)" : "",
                position: "absolute",
                marginLeft: "auto",
                marginRight: "auto",
                left: 0,
                right: 0,
                textAlign: "center",
                zIndex: 9,
                width: "90%",
                height: "90%"
              }}
            />
            </header>
      </BrowserView>
      <MobileView>
        <header className="App-header" style={{ width: "70%"}}>
          <Webcam
            mirrored={isFlipped}
            ref={webcamRef}
            style={{
              position: "absolute",
              marginLeft: "auto",
              marginRight: "auto",
              left: 0,
              right: 0,
              textAlign: "center",
              zIndex: 9,
              // width: 200,
              // height: 800,
              width: "90%", height: "90%", objectFit: "cover"
            }}
          />
          <canvas
            ref={canvasRef}
            style={{
              transform: isFlipped ? "scaleX(-1)" : "",
              position: "absolute",
              marginLeft: "auto",
              marginRight: "auto",
              left: 0,
              right: 0,
              textAlign: "center",
              zIndex: 9,
              width: "90%", height: "90%", objectFit: "cover"
            }}
          />
        </header>
      </MobileView>
    </div>
  );
}

export default FaceLandmark;
